import { Anchor, useMantineTheme } from '@mantine/core';
import classes from '@/components/HelpPopover/HelpPopover.module.css';
import { ExternalLink } from 'react-feather';

interface Props {
  link: string;
  text?: string;
  textSize?: string;
  bright?: boolean;
}

export const HelpLink = ({
  link,
  text,
  textSize = 'md',
  bright = false,
}: Props) => {
  const theme = useMantineTheme();
  const color = bright
    ? theme.other.helpColor.tooltip
    : theme.other.mainColor.accent.normal;

  const labelTextSize =
    textSize === 'sm'
      ? theme.other.typography.variants.bodySmallRegular
      : theme.other.typography.variants.bodyRegular;

  return (
    <div className={classes.container}>
      <Anchor
        data-testid="help-link"
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className={classes.link}
        display="flex"
        style={{
          whiteSpace: 'nowrap',
          color,
          alignItems: 'center',
          ...labelTextSize,
        }}
        onMouseDown={(event) => event.stopPropagation()}
        onClick={(event) => event.stopPropagation()}
      >
        <ExternalLink size={16}></ExternalLink>
        {text && <span>{text}</span>}
      </Anchor>
    </div>
  );
};
